function Content(props) {
  return <div className="content-container">{props.children}</div>
}

export default Content;